export const FETCH_COMPANY_TYPES_START = "FETCH_COMPANY_TYPES_START";
export const FETCH_COMPANY_TYPES_SUCCESS = "FETCH_COMPANY_TYPES_SUCCESS";
export const FETCH_COMPANY_TYPES_FAIL = "FETCH_COMPANY_TYPES_FAIL";

export const FETCH_COMPANY_TYPE_BY_ID_START = "FETCH_COMPANY_TYPE_BY_ID_START";
export const FETCH_COMPANY_TYPE_BY_ID_SUCCESS = "FETCH_COMPANY_TYPE_BY_ID_SUCCESS";
export const FETCH_COMPANY_TYPE_BY_ID_FAIL = "FETCH_COMPANY_TYPE_BY_ID_FAIL";
